import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export function minLength(count: number) {
  return `${i18n.tc(LocalesFields.MinimumNumberOfCharactersEntered)}: ${count}`;
}

export function passwordValidate() {
  return `${i18n.tc(
    LocalesFields.ThePasswordMustConsistOfNumbersAndUpperAndLowerCaseLatinLetters
  )}`;
}
